<template>
  <v-container>
    <div class="animated fadeInLeft delay-1s positionBrand">
      <h3 class="subtitle-2 text-weight-bold fontColor">OLÁ!</h3>
    </div>

    <v-form v-model="isFormValid" ref="form">
      <div class="animated fadeInLeft delay-1s positionFields">
        <h4 class="text-xs-center grey--text text--darken-1 font-weight-thin">
          Insira seu <span class="font-weight-bold">e-mail:</span>
        </h4>
        <v-text-field class="pt-0 mt-0"
          v-model="email"
          required
          :rules="emailRules"
          single-line>
        </v-text-field>
      </div>

      <div class="animated fadeInLeft delay-1s positionFields">
        <h4 class="text-xs-center grey--text text--darken-1 font-weight-thin">
          <span class="font-weight-bold">Confirme</span> seu e-mail:
        </h4>
        <v-text-field class="pt-0 mt-0"
          v-model="confirmedEmail"
          required
          :rules="confirmedEmailRules"
          single-line>
        </v-text-field>
      </div>

      <div class="animated fadeInLeft delay-1s positionFields">
        <h4 class="text-xs-center grey--text text--darken-1 font-weight-thin">
          Insira seu <span class="font-weight-bold">código</span> de acesso:
        </h4>
        <v-text-field class="pt-0 mt-0"
          v-model="inviteCode"
          required
          :rules="codeRules"
          single-line>
        </v-text-field>
      </div>

      <div class="animated fadeInLeft delay-1s positionFields">
        <v-btn
          class="positionButton"
          color="primary"
          :disabled="!isFormValid"
          :loading="loading"
          @click="validateInvite()"
        >
          <h4 class="text-capitalize font-weight-thin positionButton-text">Avançar</h4>
        </v-btn>
      </div>
    </v-form>

    <div class="animated fadeInLeft delay-1s position">
      <h4 class="text-xs-center grey--text text--darken-1 font-weight-thin">
        Já possui uma conta? <a href="/login" class="font-weight-medium fontColor">Entre</a>
      </h4>
    </div>
  </v-container>
</template>

<script>
import { ValidateInvite } from '@/apollo';

export default {
  data() {
    return {
      email: null,
      confirmedEmail: null,
      inviteCode: null,
      isFormValid: false,
      loading: false,
      emailRules: [
        email => !!email || 'O campo é obrigatório',
        email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || 'Este e-mail não é válido',
      ],
      confirmedEmailRules: [
        confirmedEmail => !!confirmedEmail || 'O campo é obrigatório',
        confirmedEmail => confirmedEmail === this.email || 'A confirmação do e-mail está diferente do e-mail',
      ],
      codeRules: [
        code => !!code || 'O campo é obrigatório',
      ],
    };
  },
  methods: {
    async validateInvite() {
      await this.$refs.form.validate();
      if (!this.isFormValid) return;
      this.loading = true;
      try {
        const { data } = await this.$apollo.query({
          query: ValidateInvite,
          variables: {
            customerId: this.$route.params.id,
            code: this.inviteCode,
            email: this.email,
          },
          fetchPolicy: 'no-cache',
        });

        const validatedInvite = data.validateInvite;

        localStorage.setItem('invite', JSON.stringify(validatedInvite.invite));
        localStorage.setItem('inviteCustomer', JSON.stringify(validatedInvite.customer));
        localStorage.setItem('inviteEmail', validatedInvite.inviteEmail);

        this.$router.push('/cadastro');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.positionBrand {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  margin-bottom: 80px;
}

.positionFields {
  flex-direction: column;
  align-items: center;
  width: 70%;
  margin: auto;
  margin-bottom: 30px;
}

.positionButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: auto;
}

.v-btn {
  border-radius: 7.08982px !important;
}

.position {
  margin-top: 100px;
}

.fontColor {
  color: #0C4439;
}
</style>
